// extracted by mini-css-extract-plugin
export default {"UnmarkedAsPurchasedToast__Image":"UnmarkedAsPurchasedToast-styles__UnmarkedAsPurchasedToast__Image__WmLjR"};